<template>
  <div class="authenticated">
    <div class="nav-bg container-fluid">
      <navigation></navigation>
    </div>
    <div class="container">
      <div class="application-content">
        <alert v-if="isError" type="danger"></alert>
        <h1>Student Volunteer Profile <span className="text-muted">(SV ID {{ profile.svid }})</span></h1>
        <b-form>
          <label for="firstName">Legal First Name<span class='ml-2 required'>(required)</span></label>
          <b-form-group>
            <b-form-input required type="text" v-model="firstName" id="firstName"></b-form-input>
          </b-form-group>
          <label for="lastName">Last Name<span class='ml-2 required'>(required)</span></label>
          <b-form-group>
            <b-form-input required type="text" v-model="lastName" id="lastName"></b-form-input>
          </b-form-group>
          <label for="nickname">
            Name if different than legal name
          </label>
          <b-form-group>
            <b-form-input required type="text" v-model="nickname" id="nickname"></b-form-input>
          </b-form-group>
          <label for="email">Email<span class='ml-2 required'>(required)</span></label>
          <b-form-group>
            <b-form-input required type="email" v-model="email" id="email"></b-form-input>
          </b-form-group>
          <label for="birthday">Date of Birth<span class='ml-2 required'>(required)</span></label>
          <b-form-group>
            <b-form-input required type="date" v-model="birthdate" id="birthday"></b-form-input>
          </b-form-group>
          <label style="margin-bottom: 0px" for="gender">With which gender identity(s) do you identify?<span class='ml-2 required'>(required)</span></label>
          <b-form-group>
            <b-form-checkbox-group
              v-model="gender"
              :options="genderOptions"
              name="gender"
              stacked
            />
            <b-form-input v-if="isGenderOther" name="genderIdentity" v-model="genderIdentity" type="text"></b-form-input>
          </b-form-group>
          <label style="margin-bottom: 0px" for="underrepresented">Which of the following best represents your racial and ethnic heritage?<span class='ml-2 required'>(required)</span></label>
          <b-form-group>
            <b-form-checkbox-group
              v-model="underrepresented"
              :options="raceOptions"
              name="underrepresented"
              stacked
            ></b-form-checkbox-group>
            <b-form-input v-if="isUnderrepresentedOther" name="underrepresentedGroup" v-model="underrepresentedGroup" type="text"></b-form-input>
          </b-form-group>
          <label style="margin-bottom: 0px" for="disability">
            We are committed to meeting the needs of people with disabilities or special requirements accepted into our program. <br/>
            If you require additional support and/or specific accommodations, please let us know and we will reach out to you. <span class='ml-2 required'>(required)</span>
          </label>
          <b-form-radio-group id="disability" v-model="disability" name="disability" class="radio">
            <b-form-radio style="margin-bottom: 8px" value="no">No</b-form-radio><br/>
            <b-form-radio style="margin-bottom: 8px" value="yes">Yes, I require additional support and/or specific accommodations regarding: <b-form-input size="sm" :disabled="disability !== 'yes'" name="disabilityType" v-model="disabilityType" type="text" placeholder="optional"></b-form-input></b-form-radio><br/>
          </b-form-radio-group>
          <br/>
          <label for="address1">Address Line 1<span class='ml-2 required'>(required)</span></label>
          <b-form-group >
            <b-form-input required type="text" v-model="address1" id="address1"></b-form-input>
          </b-form-group>
          <label for="address2">Address Line 2 </label>
          <b-form-group>
            <b-form-input type="text" v-model="address2" id="address2"></b-form-input>
          </b-form-group>
          <label for="city">City<span class='ml-2 required'>(required)</span></label>
          <b-form-group>
            <b-form-input required type="text" v-model="city" id="city"></b-form-input>
          </b-form-group>
          <div class="row">
              <div class="col-md-4">
              <label for="region">State/Province/Region<span class='ml-2 required'>(required)</span></label>
                <b-form-group>
                  <b-form-input required type="text" v-model="region" id="region"></b-form-input>
                </b-form-group>
              </div>
              <div class="col-md-4">
              <label for="country">Country<span class='ml-2 required'>(required)</span></label>
                <b-form-group>
                  <b-form-select required id="country" v-model="country" :options="countries" class="mb-3">
                  </b-form-select>
                </b-form-group>
              </div>
              <div class="col-md-4">
              <label for="postalCode">Zip/Postal Code<span class='ml-2 required'>(required)</span></label>
                <b-form-group>
                  <b-form-input required type="text" v-model="postalCode" id="postalCode"></b-form-input>
                </b-form-group>
              </div>
          </div>
          <div class="row">
            <div class="col col-md-12">
              <b-form-group label="Languages" label-for="languages" description="Only select languages you are comfortable communicating in on a daily basis.">
                <multiselect id="languages" track-by="value" label="text" :options="languageList" :value="getLanguages" :searchable="true" :multiple="true" :close-on-select="false" :hide-selected="true" @input="updateLanguages">
                  <template slot="tag" slot-scope="props"><span class="custom__tag"><span>{{ props.option.text }}</span><span class="custom__remove" @click="props.remove(props.option)">❌</span></span></template>
                </multiselect>
              </b-form-group>
            </div>
          </div>
          <div class="row">
            <div class="col col-md-12">
            <label for="phoneNumber">Phone Number<span class='ml-2 required'>(required)</span></label>
              <b-form-group description="Include International Dialing Code if outside U.S." label-for="phoneNumber">
                <b-form-input required type="tel" v-model="phoneNumber" id="phoneNumber"></b-form-input>
              </b-form-group>
            </div>
          </div>
          <b-form-group>
            <b-form-checkbox v-model="canText">I can receive text messages in the U.S.</b-form-checkbox>
            <b-form-checkbox v-model="canCall">I can receive phone calls in the U.S.</b-form-checkbox>
          </b-form-group>
          <b-form-group>
            <div class="row">
              <div class="col">
                <button type="button" :disabled="disabled" class="btn left-arrow-btn-primary float-md-left" @click="backHome">Back to Dashboard</button>
              </div>
              <div v-if="isMessage" class="col col-md-6">
                <alert type="primary"></alert>
              </div>
              <div class="col">
                <button type="button" :disabled="disabled" class="btn arrow-btn-primary float-md-right" @click="updateProfile">Update Profile</button>
              </div>
            </div>
          </b-form-group>
        </b-form>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapState } from 'vuex'
  import Alert from '@/components/Alert'
  import Nav from '@/components/Nav'
  import Multiselect from 'vue-multiselect'
  import router from '@/router'
  import { titles, suffixes, countries, languageList, genderList, underrepresentedList } from '@/util/SelectLists'

  const generateProfileVuexSetters = (fields) => {
    let computed = {}
    fields.forEach(field => {
      computed[field] = {
        get () {
          return this.$store.state.user.profile[field]
        },
        set (value) {
          this.$store.commit('user/updateProfile', { name: field, value })
        }
      }
    })
    return computed
  }

  const generateAddressVuexSetters = (fields) => {
    let computed = {}
    fields.forEach(field => {
      computed[field] = {
        get () {
          return this.$store.state.user.profile.address[field]
        },
        set (value) {
          this.$store.commit('user/updateProfileAddress', { name: field, value })
        }
      }
    })
    return computed
  }

  export default {
    name: 'Profile',
    data () {
      return {
        titles: titles,
        suffixes: suffixes,
        countries: countries,
        languageList: languageList,
        disabled: false,
        genderOptions: genderList,
        raceOptions: underrepresentedList
      }
    },
    computed: {
      ...generateProfileVuexSetters([
        'firstName',
        'lastName',
        'nickname',
        'birthdate',
        'phoneNumber',
        'canText',
        'canCall',
        'email',
        'gender',
        'genderIdentity',
        'underrepresented',
        'underrepresentedGroup',
        'disability',
        'disabilityType'
      ]),
      ...generateAddressVuexSetters([
        'address1',
        'address2',
        'city',
        'region',
        'country',
        'postalCode'
      ]),
      ...mapGetters(['isError', 'isMessage']),
      ...mapGetters('user', ['getLanguages']),
      ...mapState('user', ['profile']),
      isGenderOther: function () {
        return this.gender && this.gender.includes('other')
      },
      isUnderrepresentedOther: function () {
        return this.underrepresented && this.underrepresented.includes('other')
      }
    },
    methods: {
      updateProfile (e) {
        e.preventDefault()
        if (!this.profile.birthdate ||
        !this.profile.firstName ||
        !this.profile.lastName ||
        this.profile.gender.length <= 0 ||
        this.profile.underrepresented.length <= 0 ||
        !this.profile.disability ||
        !this.profile.phoneNumber ||
        !this.profile.address.address1 ||
        !this.profile.address.city ||
        !this.profile.address.region ||
        !this.profile.address.country ||
        !this.profile.address.postalCode) {
          console.log(this.profile)
          this.$store.commit('error', { message: 'Please fill in all required fields' })
          window.scrollTo(0, 0)
        } else {
          this.disabled = true
          this.$store.dispatch('user/saveAttributes').then(() => {
            this.disabled = false
            router.push('/')
          }).catch(() => {
            this.disabled = false
          })
        }
      },
      updateLanguages (value) {
        this.$store.commit('user/updateProfile', { name: 'languages', value })
      },
      backHome (e) {
        e.preventDefault()
        this.disabled = true
        router.push('/')
      }
    },
    components: {
      alert: Alert,
      navigation: Nav,
      multiselect: Multiselect
    },
    created: function () {
      if (!this.$store.state.user.loadedAttributes) {
        this.$store.dispatch('user/loadAttributes')
      }
    }
  }
</script>

<style>
  @import '../../../node_modules/vue-multiselect/dist/vue-multiselect.min.css';
  #languages {
    height: 100%;
    padding: 0px;
  }
  .custom-select {
    height: 3rem !important;
  }
  .multiselect {
    height: 3rem !important;
  }
  .multiselect .multiselect__tags {
    height: 100%;
  }
  span.required {
    color: red;
  }
</style>



// WEBPACK FOOTER //
// src/components/user/Profile.vue